/**
 * O botão de contorno das toolbars do SM.
 *
 * Papel: reproduz `.toolbar .btn.primary` (l. 281–287) — 32 px de altura,
 * Outfit 11 px em caixa alta, texto e borda bege, fundo transparente também sob
 * o ponteiro. É o "+ Novo registro" e o "Exportar PDF".
 *
 * Como usar: o ícone, quando há, entra como primeiro filho, com o `font-size`
 * do botão (11 px); o `gap` de 6 px já separa os dois.
 */
import { type ComponentProps } from 'react';

import { cn } from '@/shared/lib/utils';

/**
 * Um botão de toolbar.
 *
 * @param className - Classes de quem chama, aplicadas por último pelo `cn()`.
 * @param type - O `type` do botão; `button` quando ausente.
 * @returns O botão.
 */
export function BotaoDaBarra({
  className,
  type = 'button',
  ...props
}: ComponentProps<'button'>) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-[5px] border border-emb-acao-borda bg-transparent px-3.5 font-outfit text-[11px] font-normal tracking-[0.08em] text-emb-acao uppercase hover:border-emb-acao-borda-hover hover:text-brass-light',
        className,
      )}
      {...props}
    />
  );
}
